import { Injectable, OnInit, Injector } from '@angular/core';
import { ToasterUtilService } from './toaster-util.service';
import { SessaoModel } from './model/sessao.model';
import { PermissaoModel } from './model/permissao.model';
import { Funcionalidade } from './enum/funcionalidade.enum';
import { TipoAcesso } from './enum/tipo-acesso.enum';
import { AutenticacaoService } from '../service/autenticacao.service';
import { TokenModel } from './model/token.model';
import { Router, ActivatedRoute } from '@angular/router';
import { ImagemModel } from './model/imagem.model';
import { MenuService } from '../core/menu/menu.service';
import { menu } from '../routes/menu';
import { UtilService } from './util.service';
//import {JwtHelper} from 'angular2-jwt';


interface Token {
  exp: number;
  user_name: string;
  authorities: Array<string>;
  jti: string;
  client_id: string;
  scope: Array<string>;
}

@Injectable()
export class SessaoUtil {

    returnUrl: string;

    public idEmpresaLogada: number;
    public nomeEmpresaLogada: string;
    public estadoEmpresa: string;
    public idUsuarioLogado: number;
    public nomeUsuarioLogado: string;
    public login: string;
    public loginTemporario: string;
    public tipoAcesso: TipoAcesso;
    public suporteTemporario: Boolean;
    public permissoes: {[key: string]: PermissaoModel};
    public token: TokenModel;
    public imagem: ImagemModel;
    public cnpjEmpresaLogada: string;
    //private access_token: Token;
    //private jwtHelper: JwtHelper = new JwtHelper();

    constructor(
      private autenticacaoService: AutenticacaoService,
      public toasterUtil: ToasterUtilService,
      private injector: Injector,
      private router: Router,
      private route: ActivatedRoute,
      public menuService: MenuService
    ){
      this.router = this.injector.get(Router);
      this.carregaDadosSessao();
      this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '';
    }

    carregaDadosSessao(){
        if ((localStorage.getItem('nfceapi_lembreMe') && localStorage.getItem('nfceapi_lembreMe') == 'true') || localStorage.getItem('nfceapi_dadosSessao')) {
            let dadosSessao = JSON.parse(atob(localStorage.getItem('nfceapi_dadosSessao')));
            this.preencheDadosSessao(dadosSessao);

            this.autenticacaoService.tokenValid(this.getToken()).then((resp) => {
              if(resp != null && resp){
               if(!UtilService.empty(this.returnUrl)){
                this.router.navigate([this.returnUrl]);
               }

              }else{
                this.limpaDadosSessao();
              }
            }).catch(erro => this.toasterUtil.erro(erro));
            //this.router.navigate(['/dashboard']);
        }else{
          this.router.navigate(['/login']);
        }
    }

    limpaDadosSessao() {
       this.idEmpresaLogada = null;
       this.nomeEmpresaLogada = null;
       this.estadoEmpresa = null;
       this.idUsuarioLogado = null;
       this.nomeUsuarioLogado = null;
       this.permissoes = null;
       this.tipoAcesso = null;
       this.token = null;
       this.imagem = null;
       this.login = null;
       this.loginTemporario = null;
       this.suporteTemporario = null;
       this.cnpjEmpresaLogada = null;
       localStorage.removeItem('usuarioLogado');
       localStorage.removeItem('nfceapi_dadosSessao');
       this.menuService.cleanMenu();
       //this.access_token = null;
    }

    preencheDadosSessao(sessao: SessaoModel) {
        this.idEmpresaLogada = sessao.idEmpresa;
        this.nomeEmpresaLogada = sessao.nomeEmpresa;
        this.estadoEmpresa = sessao.estadoEmpresa;
        this.idUsuarioLogado = sessao.idUsuario;
        this.nomeUsuarioLogado = sessao.nomeUsuarioLogado;
        this.tipoAcesso = sessao.tipoAcesso;
        this.permissoes = sessao.permissoes;
        this.token = sessao.token;
        this.imagem = sessao.imagem;
        this.login = sessao.login;
        this.loginTemporario = sessao.loginTemporario;
        this.suporteTemporario = sessao.suporteTemporario;
        this.cnpjEmpresaLogada = sessao.cnpjEmpresa;
        this.menuService.addMenu(menu, this.permissoes);
    }

    possuiPermissao(fundionalidade: Funcionalidade){
        if(fundionalidade == null || fundionalidade == undefined) {
            return false;
        }

        return (this.permissoes[fundionalidade] != null && this.permissoes[fundionalidade] != undefined && (this.permissoes[fundionalidade].somenteLeitura || this.permissoes[fundionalidade].acessoTotal));
    }

    possuiPermissaoTotal(fundionalidade: Funcionalidade){
      if(fundionalidade == null || fundionalidade == undefined) {
          return false;
      }
      return (this.permissoes[fundionalidade] != null && this.permissoes[fundionalidade] != undefined && this.permissoes[fundionalidade].acessoTotal);
    }

    isUsuarioAcessoTotal(){
      return (!UtilService.empty(this.tipoAcesso) && this.tipoAcesso.toString() == TipoAcesso[TipoAcesso.ACESSO_TOTAL]) ? true : false;
    }

    isUsuarioAdministrador() {
      let retorno = (this.idUsuarioLogado == 1 && this.login == 'ats') || (this.idUsuarioLogado == 2 && this.login == 'suporteats');
      return retorno;
    }

    setToken(token : TokenModel) {
      //this.access_token = this.jwtHelper.decodeToken(token.access_token);
      this.token = token;
    }

    getToken() : TokenModel{
       return this.token;
    }

    logoff(){
      this.autenticacaoService.logoff(this.getToken()).then(resp => {
                                        this.limpaDadosSessao();
                                        this.router.navigate(['/login']);
                                     }).catch(erro => this.toasterUtil.erro(erro));

    }

    meusDados(){
      this.router.navigate(['/usuarios/editaUsuario/' + this.idUsuarioLogado]);
    }

  //   getAcessToken() : Token{
  //     return this.access_token;
  //  }


}



// WEBPACK FOOTER //
// ./src/app/util/sessao-util.ts